module.exports = __webpack_public_path__ + "static/media/totizeke.3f20d08e.png";